import { formatKr } from "../lib/format";

export const rateTone = (r) => (r == null ? "" : r >= 80 ? "good" : r >= 60 ? "ok" : "low");

const Kr = ({ ore, testid }) => (
  <b className={ore ? "" : "muted"} data-testid={testid}>{ore ? formatKr(ore) : "0 kr."}</b>
);

export function OfferRevenue({ id, sales, tab }) {
  if (!sales || tab === "drafts") return null;
  if (tab === "upcoming" && !sales.reserved_qty && !sales.picked_qty) return null;
  return (
    <div className="orv" data-testid={`offer-revenue-${id}`}>
      <span className="orv-item">
        <small>Omsat</small> <Kr ore={sales.revenue} testid={`offer-revenue-value-${id}`} />
        <small className="muted" data-testid={`offer-picked-${id}`}>{sales.picked_qty} udleveret</small>
      </span>
      {sales.reserved_value > 0 && (
        <span className="orv-item muted">
          <small>Reserveret for</small> <b data-testid={`offer-reserved-value-${id}`}>{formatKr(sales.reserved_value)}</b>
        </span>
      )}
      {tab === "archive" && (
        <span className={`orv-item orv-rate ${rateTone(sales.pickup_rate)}`}>
          <small>Afhentning</small>{" "}
          <b data-testid={`offer-rate-${id}`}>{sales.pickup_rate == null ? "–" : `${sales.pickup_rate} %`}</b>
        </span>
      )}
    </div>
  );
}

const sum = (cards, k) => cards.reduce((a, c) => a + (c.sales?.[k] || 0), 0);

export function TabSummary({ tab, label, cards }) {
  if (!cards.length || tab === "drafts") return null;
  const rev = sum(cards, "revenue");
  const res = sum(cards, "reserved_value");
  const picked = sum(cards, "picked_qty");
  const ns = sum(cards, "no_show_qty");
  const rate = picked + ns ? Math.round((100 * picked) / (picked + ns)) : null;
  return (
    <div className="orv-sum" data-testid="tab-summary">
      <b>{label}{tab === "archive" ? ` (${cards.length})` : ""}:</b>{" "}
      {tab === "archive" ? "omsat i alt" : "omsat"} <b data-testid="tab-summary-revenue">{rev ? formatKr(rev) : "0 kr."}</b>
      {res > 0 && <> · reserveret for <b data-testid="tab-summary-reserved">{formatKr(res)}</b></>}
      {tab === "archive" && rate != null && (
        <> · gns. afhentning <b className={`orv-rate ${rateTone(rate)}`} data-testid="tab-summary-rate">{rate} %</b></>
      )}
    </div>
  );
}
